import { render, staticRenderFns } from "./AiDashboardCard.vue?vue&type=template&id=08966052&"
import script from "./AiDashboardCard.vue?vue&type=script&lang=js&"
export * from "./AiDashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports